import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Advertisers = [
    {
      id: '01',
      image: '/jan-feb-2023/ads/usf.jpg',
      link: 'https://bard.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Shakespeare Festival',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/jan-feb-2023/ads/ufo.jpg',
      link: 'https://utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/jan-feb-2023/ads/u-of-u.jpg',
      link: 'https://osher.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'University of Utah',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/jan-feb-2023/ads/adibs.jpg',
      link: 'https://www.adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Adibs Rug Gallery',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/jan-feb-2023/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Tuacahn Amphitheatre',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/jan-feb-2023/ads/jerry-seiner.jpg',
      link: 'https://www.jerryseinercadillac.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Jerry Seiner Cadillac',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/jan-feb-2023/ads/william-call.jpg',
      link: 'https://www.williamcall.net/fantasy/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/jan-feb-2023/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/jan-feb-2023/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/jan-feb-2023/ads/minky-couture.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/jan-feb-2023/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '13',
      image: '/jan-feb-2023/ads/ufirst.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
  ];

  Advertisers.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Advertisers.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
